import React from 'react';
import { Tag } from '../types/user';
import { ArrowPathIcon } from '@heroicons/react/24/solid';

interface TagBadgeProps {
  tag: Tag;
  changed?: boolean;
}

const TagBadge: React.FC<TagBadgeProps> = ({ tag, changed }) => {
  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-md font-medium ${changed ? "bg-yellow-100 text-yellow-800" : "bg-gray-100 text-gray-800"} text-xs`}>
      {tag.name}
      {changed && <ArrowPathIcon className="h-3 w-3 ml-1 text-blue-900" aria-hidden="true" />}
    </span>
  );
};

export default TagBadge;
